import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Marketdate } from './marketdate.model';
import { MarketdatePopupService } from './marketdate-popup.service';
import { MarketdateService } from './marketdate.service';
import { Marketday, MarketdayService } from '../marketday';

@Component({
    selector: 'jhi-marketdate-dialog',
    templateUrl: './marketdate-dialog.component.html'
})
export class MarketdateDialogComponent implements OnInit {

    marketdate: Marketdate;
    authorities: any[];
    isSaving: boolean;

    marketdays: Marketday[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketdateService: MarketdateService,
        private marketdayService: MarketdayService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdate', 'marketStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(
            (res: Response) => { this.marketdays = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketdate.id !== undefined) {
            this.marketdateService.update(this.marketdate)
                .subscribe((res: Marketdate) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdateService.create(this.marketdate)
                .subscribe((res: Marketdate) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Marketdate) {
        this.eventManager.broadcast({ name: 'marketdateListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdayById(index: number, item: Marketday) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketdate-popup',
    template: ''
})
export class MarketdatePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdatePopupService: MarketdatePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdatePopupService
                    .open(MarketdateDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdatePopupService
                    .open(MarketdateDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate-dialog.component.ts